import axios from 'axios'
import store from '@/vuex/store'
import router from '@/router'
import { ROUTE_INDEX } from '../const/route'

function createRequest () {
  const baseURL = process.env.VUE_APP_API_BASE

  const instance = axios.create({
    baseURL,
    validateStatus: () => (true)
  })

  /**
   * before send request
   * add Authorization header
   */

  instance.interceptors.request.use(
    (config) => {

      if (config.method == 'get') {
        config.params = config.params || {};
        config.params['domain'] = window.location.host;
      }

      const token = store.getters['auth/GETTERS_TOKEN']
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    }
  )

  /**
   * after get response data
   * convert response style to [error, result]
   */

  instance.interceptors.response.use(
    (response) => {
      const { status, data } = response

      // if stauts code == 401
      // do logout

      if (status === 401) {
        store.dispatch('auth/ACTION_LOGOUT')
        router.push({
          name: ROUTE_INDEX
        }).catch(() => { })
        return [data.message, data, null, null, status]
      }

      if (status < 200 || status > 300) {
        return [data.message, data.data, null, null, status]
      }
      // if something error
      // response error message and raw data


      const { data: result, message, meta } = data
      return [null, result, message, meta, status]
    }, () => {
      // router.push('/login').catch(()=>{}); 
      // return ['มีบางอย่างไม่ถูกต้อง กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ', null, null, null, 500]
    }
  )

  return instance
}

export default createRequest()